// Homepage management routes
import HomePage from '../../views/HomePage.vue'
import CreateHomepageSection from '../../views/CreateHomepageSection.vue'
import HomepageSectionsView from '../../views/HomepageSectionsView.vue'
import HomepageSectionDetailView from '../../views/HomepageSectionDetailView.vue'
import HomepageSectionEditView from '../../views/HomepageSectionEditView.vue'
import UpdateHomepageSectionView from '../../views/UpdateHomepageSectionView.vue'
import LandingItems from '../../components/LandingItems.vue'
import LandingPopup from '../../components/LandingPopup.vue'

export default [
  {
    path: '/homepage',
    name: 'HomePage',
    component: HomePage,
    meta: { 
      requiresAuth: true,
      title: 'Homepage Management'
    }
  },
  {
    path: '/homepage/create',
    name: 'CreateHomepageSection',
    component: CreateHomepageSection,
    meta: { 
      requiresAuth: true,
      title: 'Create Homepage Section'
    }
  },
  {
    path: '/homepage/sections',
    name: 'HomepageSections',
    component: HomepageSectionsView,
    meta: { 
      requiresAuth: true,
      title: 'Homepage Sections'
    }
  },
  {
    path: '/homepage/sections/:id',
    name: 'HomepageSectionDetail',
    component: HomepageSectionDetailView,
    meta: { 
      requiresAuth: true,
      title: 'Section Details'
    }
  },
  {
    path: '/homepage/sections/:id/edit',
    name: 'HomepageSectionEdit',
    component: HomepageSectionEditView,
    meta: { 
      requiresAuth: true,
      title: 'Edit Section'
    }
  },
  {
    path: '/homepage/sections/:id/update',
    name: 'UpdateHomepageSection',
    component: UpdateHomepageSectionView,
    meta: { 
      requiresAuth: true,
      title: 'Update Section'
    }
  },
  {
    path: '/landing-popups',
    name: 'LandingPopups',
    component: LandingPopup,
    meta: { 
      requiresAuth: true,
      title: 'Landing Popups'
    }
  },
  {
    path: '/landing-items',
    name: 'LandingItems',
    component: LandingItems,
    meta: { 
      requiresAuth: true,
      title: 'Landing Items'
    }
  }
] 